import styled from '@emotion/styled';

import {Divider} from '@/components/Divider';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;

  ${Divider} {
    margin: 0 8px;
  }
`;
